import {Locale} from '@aboutyou/config';

const showLoginAsDefaultCountries = [
  Locale.cs_CZ,
  Locale.de_DE,
  Locale.en_DE,
  Locale.de_CH,
  Locale.fr_CH,
  Locale.en_CH,
  Locale.de_AT,
  Locale.en_AT,
  Locale.fr_BE,
  Locale.nl_BE,
  Locale.nl_NL,
  Locale.en_NL,
];

export const getShowLoginAsDefault = (locale: Locale) => {
  return showLoginAsDefaultCountries.includes(locale);
};
